import React from 'react'
import { Button } from 'react-bootstrap'
import { Plus } from 'react-feather'
import { useNavigate } from 'react-router-dom'

const NewInvoiceButton = () => {
	const navigate = useNavigate()
	return (
		<Button
			variant="primary"
			size="sm"
			onClick={() => {
				navigate('/invoice/new')
			}}
		>
			<div className="d-flex align-items-center justify-content-between">
				<Plus size={16} strokeWidth={3} className="mr-2" />
				<span>New Invoice</span>
			</div>
		</Button>
	)
}

export default NewInvoiceButton
